export interface FinancialDraftState {
    documentStatus?: string | null;
    postingStatus?: string | null;
    postedAt?: Date | string | number | null;
    owningCompany?: { id?: number } | null;
    owningCompanyId?: number | null;
}

/** Financial edits and cancellation use the same rule for manual and generated documents. */
export function isEditableFinancialDraft(document: FinancialDraftState | null | undefined, companyId?: number): boolean {
    return !!document && document.documentStatus?.toUpperCase() === 'DRAFT'
        && document.postingStatus?.toUpperCase() !== 'POSTED' && document.postedAt == null
        && (companyId == null || (document.owningCompany?.id ?? document.owningCompanyId) === companyId);
}
